<!-- 上主下从模版 -->
<template>
  <div>
    <div class="box" id="box" ref="box">
      <div class="top" id="top">
        <el-main>
          <!-- {{ topHeight }} -->
          <data-tablec-new
            ref="master"
            @row-dblclick="$emit('row-dblclick', $event)"
            @data-loaded="masterOnloadRow"
            @master-table-refreshed="handleMasterTableRefresh"
            @params-query="handQuery"
            :splitUrl="splitUrl"
            :bottomHight="zbParams.bottomHight"
            @onLoad="getData"
            :height="topHeight || tableHeightFn()"
            :option="{
              searchHidden: zbParams.searchHidden,
              topButtonArea: zbParams.topButtonArea,
              tableHeight: topHeight || zbParams.tableHeight,
              selection: typeof zbParams.selection === 'boolean' ? zbParams.selection : true,
              exportBtn: zbParams.exportBtn || false,
              filterBtn: false, // 取消高级筛选
              pageSize: masterPageSize || 10,
            }"
            :filterObj="zbParams.filterObj || {}"
            :colObj="{
              tableCellClick,
              addMasterSlaveClick,
              ...zbParams,
            }"
          >
            <template slot="TOP_BUTTON">
              <slot name="TOP_BUTTON"></slot>
            </template>
            <template slot="RIGHT_BUTTON">
              <slot name="RIGHT_BUTTON"></slot>
              <el-tooltip class="item" effect="dark" content="高级检索" placement="top">
                <el-button icon="iconfont icon-canshu" size="mini" circle @click="fliterClick"></el-button>
              </el-tooltip>
            </template>
            <template slot="menuLeft" slot-scope="{ row }">
              <slot name="menuLeft" :row="row"></slot>
            </template>
            <template slot="menuRight" slot-scope="{ row }">
              <slot name="menuRight" :row="row"></slot>
            </template>
            <template slot="searchSlot" slot-scope="{ query }">
              <slot name="searchSlot" :query="query"></slot>
            </template>
            <template slot="APPTIME" slot-scope="{ row }">
              <slot name="APPTIME" :row="row"></slot>
            </template>
            <template slot="top">
              <slot name="top"></slot>
            </template>
            <template slot="pageSlot">
              <slot name="pageSlot"></slot>
            </template>
          </data-tablec-new>
        </el-main>
      </div>
      <div class="resize" id="resize" title="收缩侧边栏">・・・</div>
      <div class="bottom" id="bottom">
        <el-main>
          <data-tablec-new
            ref="slave"
            :splitUrl="splitUrl"
            @data-loaded="slaveOnloadRow"
            @select-slave-data="selectSlaveData"
            :height="tableHeightFn()"
            :option="{
              // selection: false,
              exportBtn: false,
              // topFunctionButton: false,
              searchHidden: cbParams.searchHidden,
              topButtonArea: cbtopButtonArea && cbParams.topButtonArea,
              tableHeight: bottomHeight || cbParams.tableHeight,
              noLoad: true, // 表格不默认加载
              filterBtn: false, // 取消高级筛选
              pageSize: slavePageSize || 5,
            }"
            :filterObj="this.filterObjFromA ? this.filterObjFromA : this.baseFilterObj"
            :colObj="{
              ...cbParams,
              col: [],
              addForm: {
                [zcbGlgx.chilProp]: glID,
              },
            }"
          >
            <template slot="TOP_BUTTON">
              <slot name="SLAVE_TOP_BUTTON"></slot>
            </template>
          </data-tablec-new>
        </el-main>
      </div>
    </div>

    <!-- 主从表分布式弹窗 -->
    <addMasterSlave-dialog
      ref="addMasterSlave"
      :visible.sync="addMasterSlaveDialog"
      :masterAllOption="masterAllOption"
      :masterColObj="masterColObj"
      :masterAddForm="masterAddForm"
      :masterFormOption="masterFormOption"
      :slaveAllOption="slaveAllOption"
      :slaveColObj="slaveColObj"
      :splitUrl="splitUrl"
      :isReq="zbParams.isReq"
      :addTitle="zbParams.addTitle"

      @closeClick="masterOnLoad"

    ></addMasterSlave-dialog>

    <!-- 过滤弹窗 -->
    <!-- {{ filterCtrl }} -->
    <filter-dialog :visible.sync="filterCtrl" @submit="filterSubmit" :column="filterColumn" :groupColumn="groupColumn" :colObj="{}" :isGroup="true"></filter-dialog>
  </div>
</template>

<script>
import AddMasterSlaveDialog from './AddMasterSlaveDialog';
import FilterDialog from '@/components/table/template/filterDialog';
import dataTablecNew from '@/components/table/dataTablecNew';
export default {
  components: { dataTablecNew, AddMasterSlaveDialog, FilterDialog },
  props: {
    masterPageSize: {type: Number, default: 10},
    slavePageSize: {type: Number, default: 5},
    splitUrl: {type: Object, default: {}},
    isOnLoadSlave: {type: Boolean, default: true},
    title: {
      // 标题
      type: String,
      default: "",
    },
    zbParams: {
      // 主表参数 opid， type 等
      type: Object,
      default: {
        searchHidden: false,
        topButtonArea: true,
      },
    },
    cbParams: {
      // 从表参数 opid， type 等
      type: Object,
      default: {
        searchHidden: false,
        topButtonArea: true,
        query: {},
      },
    },
    ljzParams: {
      // 懒加载参数
      type: Object,
      default: () => {},
    },
    zbShow: {
      // 主表展示字段
      type: String,
      default: "ID",
    },
    zcbGlgx: {
      // 主从表关联关系字段 parProp(主表字段) chilProp（从表字段）
      type: Object,
      default: () => {},
    },
    downMbObj: {
      type: Object,
      default: {},
    },
    filterObjFromA: {
      type: Object,
      default: null // 初始为null，表示A(最外层从表过滤条件)还未修改
    }
  },
  data() {
    return {
      topHeight: 0, // 顶部的高度
      bottomHeight: 0, // 底部的高度
      filterCtrl: false, // 高级筛选控制显示隐藏
      filterColumn: [], // 高级筛选的属性
      groupColumn: [], // 高级筛选的属性

      addMasterSlaveDialog : false, // 新增主从数据弹框状态
      masterAllOption: {}, // 主表配置
      masterColObj: {}, // 主表配置
      masterAddForm: {}, // 主表表单
      masterFormOption: {}, // 主表表单配置
      slaveAllOption: {}, // 从表配置
      slaveColObj: {}, // 从表配置

      firstEnter: true,
      treeData: [],
      filterText: "",
      loading: false,
      cbtopButtonArea: true, // 从表顶部按钮
      query: {
        ZGDWID: "",
        ZGDWMC: "",
      },
      glID: "",
      selTags: "",
      lastSentFilter: {}, // 缓存上次发送的过滤条件，防重复emit
    };
  },
  watch: {
    addMasterSlaveDialog(newVal) {
      if (!newVal) {
        console.log("弹窗已关闭，执行 masterOnLoad");
        this.$refs.addMasterSlave.$refs.addForm.resetForm();
        this.$refs.addMasterSlave.$refs.reqAddStep2.onLoad();
        this.$store.dispatch('masterTable/clearAddForm');
      }
    },
    // 新增：只监听glID变化（B组件自身的原始过滤值）
    glID: {
      immediate: true,
      handler() {
        this.sendBaseFilterToA();
      }
    },
  },
  computed: {
    // 定义B的原始过滤条件（完全保留原有逻辑）
    baseFilterObj() {
      console.log("glID的值",this.glID);
      return {
        [this.zcbGlgx.chilProp]: this.glID
      };
    }
  },
  methods: {

    // 新增：同步A传递的cbParams.query到孙组件的query，并刷新
    syncSlaveQuery() {
      if (this.$refs.slave && this.$refs.slave.$refs.child) {
        const slaveChild = this.$refs.slave.$refs.child;
        // 核心：把A的cbQuery（已传到B的cbParams.query）赋值给孙组件的query
        slaveChild.query = {
          ...slaveChild.query, // 保留孙组件原有query（如有）
          ...this.cbParams.query, // 覆盖/新增A传递的动态条件（SHANGPINMING等）
        };
        console.log("B组件同步孙组件query：", slaveChild.query);
        // 刷新孙组件，让新query生效（关键）
        slaveChild.onLoad();
      }
    },

    sendBaseFilterToA() {
      const baseFilter = this.baseFilterObj;
      if (JSON.stringify(baseFilter) !== JSON.stringify(this.lastSentFilter)) {
        this.lastSentFilter = { ...baseFilter };
        // ========== 核心修改：延迟触发base-filter-change，确保A先拿到row值 ==========
        this.$nextTick(() => {
          // 等待first-row/row-click事件完成赋值
          setTimeout(() => {
            this.$emit('base-filter-change', baseFilter);
          }, 0); // 0ms延迟，确保事件队列顺序执行
        });
      }
    },

    // 高级筛选弹出
    fliterClick(){
      console.log(this.$refs.master.$refs.child.column);
      this.filterColumn = [
        ...this.$refs.master.$refs.child.column,
        ...this.$refs.slave.$refs.child.column,
      ]
      this.groupColumn = [
        {
          label: "主表属性",
          prop: "master",
          options: this.$refs.master.$refs.child.column,
        },
        {
          label: "从表属性",
          prop: "slave",
          options: this.$refs.slave.$refs.child.column,
        }
      ]
      console.log(this.filterColumn);
      this.filterCtrl=true;
    },
    //增加过滤条件按钮
    filterSubmit(params){
      this.filterCtrl=false;
      this.$refs.master.$refs.child.query.highSearch = params;
      console.log(this.$refs.master.$refs.child);
      this.$refs.master.$refs.child.onLoad();

      // this.query.highSearch=params;
      // 刷新
      // this.onLoad();
    },
    //获取从表当前页所有行数据（刚加载完毕的数据）
    slaveOnloadRow(tableData){
      this.$emit('slave-data-loaded', tableData);
    },
    masterOnloadRow(tableData){
      this.$emit('master-data-loaded', tableData);
    },
    //获取复选框选中的从表数据！
    selectSlaveData(selectData){
      this.$emit('select-slave-data',selectData);
    },
    //主表获取查询参数
    handQuery(query, callback){
      this.$emit('params-query', query, callback);
    },
    // 刷新主表
    masterOnLoad(){
      this.$refs.master.$refs.child.onLoad();
    },
    // 主从表新增
    addMasterSlaveClick(btn,row){
      //console.log("我是列啊啊啊啊啊："+this.$refs.master.$refs.child.column);
      // console.log(btn,row);
      //console.log("*****allOption*****"+this.$refs.slave.$refs.child.allOption);
      //console.log("*****colObj*****"+this.$refs.slave.$refs.child.colObj);

      this.masterAllOption = this.$refs.master.$refs.child.allOption;
      console.log(this.masterAllOption);
      this.masterColObj = this.$refs.master.$refs.child.colObj;


      this.slaveAllOption = this.$refs.slave.$refs.child.allOption;
      console.log(this.slaveAllOption);
      this.slaveColObj = this.$refs.slave.$refs.child.colObj;

      let addList=[];
      let addform={};
      let column=this.deepClone(this.masterAllOption.column);
      console.log(column);
      for (let i = 0; i < column.length; i++) {
        const element = column[i];
        if(element.addDisplay===true){
          if(element.addDisabled===true){
            element.disabled=true;
          }
          addList.push(element);
        }
        if(element.value){
          addform[element.prop]=element.value;
        }
      }
      // console.log(addform,this.masterColObj.addForm,this.masterAddForm);
      this.masterAddForm = {...addform,...this.masterColObj.addForm};
      this.masterFormOption={
        type:'add',
        submitText: '下一步',
        styleType:'blue',
        column:addList,
        back: false,
      }
      this.$nextTick(()=>{
        this.addMasterSlaveDialog= true;
      })
    },
    addClick(empty){
      if(empty) this.addForm={};
      let addList=[];
      let addform={};
      let column=this.deepClone(this.allOption.column);
      for (let i = 0; i < column.length; i++) {
        const element = column[i];
        if(element.addDisplay===true){
          if(element.addDisabled===true){
            element.disabled=true;
          }
          addList.push(element);
        }
        if(element.value){
          addform[element.prop]=element.value;
        }
      }
      this.addForm = {...addform,...this.colObj.addForm,...this.addForm};
      this.formOption={
        type:'add',
        submitText: '保存',
        styleType:'blue',
        column:addList,
      }
      this.addDialog=true;
    },
    // 开始垂直拖动
    startDragV(e) {
      this.draggingV = true;
      this.startY = e.clientY;
      this.startTopHeight = this.topHeight;
      this.startBottomHeight = this.bottomHeight;
    },
    //获取第一级数据
    getData(data) {
      //如果设置false，则搜索不加载从表，只有点击主表记录，才加载从表
      if(this.isOnLoadSlave == false){
        return;
      }
      console.log(data);
      // if (!this.$route.query.runId) return;
      // this.loading = true;
      // const res = await getShow(1, 20, this.$route.query.runId, {
      //   // extendTreeType: 2,
      //   ...this.zbParams,
      // });
      if (this.zcbGlgx.parProp) {
        if(data.length>0){
          this.glID = data[0][this.zcbGlgx.parProp];
          this.$nextTick(async () => {
            // 第一步：触发first-row，给A传值
            this.$emit('first-row', data[0]);
            console.log("第一步：触发first-row，传值给A");
            
            // 第二步：触发tableCellClick，触发row-click传值
            const firstRow = document.querySelector('.top .el-table__row:first-child');
            // if (firstRow) {
            //   firstRow.click();
            //   this.tableCellClick(data[0], {}, {}, {});
            // }
            this.tableCellClick(data[0], {}, {}, {});
            
            // 第三步：手动触发glID监听，通知A改条件
            this.sendBaseFilterToA();

            // ========== 核心：等待A改完条件（通用延迟，不影响其他场景） ==========
            // 微任务延迟：等A的filterObjFromA赋值完成
            await new Promise(resolve => setTimeout(resolve, 50)); 
            // 第四步：加载从表（此时A已改完条件）
            this.$refs.slave.$refs.child.onLoad();
            console.log("通用B：等待A改条件后加载从表，当前filterObj：", this.filterObjFromA || this.baseFilterObj);
            // ========== 修改结束 ==========
          });
          this.cbtopButtonArea = this.cbParams.topButtonArea || true;
        }else{
          // this.cbtopButtonArea = false;
          // 如果topButtonArea为false，不显示顶部按钮区域
          this.cbtopButtonArea = this.cbParams.topButtonArea !== false; 
          this.$refs.slave.$refs.child.onLoad(true);
        }
      } else {
        this.$message.warning("请绑定主从表关联主表字段！");
      }
      return
      this.treeData = res.data.data.records;
      if (this.treeData.length > 0 && this.treeData[0][this.zcbGlgx.parProp]) {
      } else {
        this.glID = "-1";
      }
      this.loading = false;
    },
    // 当某个单元格被点击时会触发该事件
    tableCellClick(row, column, cell, event) {
      console.log(row, column, cell, event);
      if (this.zcbGlgx.parProp) {
        this.glID = row[this.zcbGlgx.parProp];
        this.$emit('row-click', row);
        // 触发A改条件
        this.sendBaseFilterToA();
      } else {
        return this.$message.warning("请绑定主从表关联主表字段！");
      }
      this.$nextTick(() => {
        //如果存在modifyFilterInA方法就调用
        if (this.$parent && typeof this.$parent.modifyFilterInA === 'function') {
          this.$parent.modifyFilterInA();
        }
        // 50ms延迟（通用值，不影响其他场景），等A的filterObjFromA赋值
        setTimeout(() => {
          this.$refs.slave.$refs.child.onLoad();
          console.log("通用B：点击行后等待A改条件，加载从表");
        }, 50);
      });
    },
    // 获取表格最大高度
    tableHeightFn(){
      let height = document.getElementById("avue-view");
      // console.log(height);
      if(height){
        if(height.clientHeight>=400){
          return height.clientHeight/2-20;
        }else{
          return 220
        }
      }
    },

    // 拖拉事件
    dragControllerDiv() {
      let _this = this;
      const box = this.$refs.box;
      const resize = box.querySelector('.resize');
      const top = box.querySelector('.top');

      // 鼠标按下事件
      resize.onmousedown = function (e) {
        // 记录坐标起始位置
        let startY = e.clientY;
        const table = _this.$refs.master.$refs.child;
        const startTableHeight = Number(table.allOption.tableHeight || table.tableHeightFn());
        const reservedHeight = Number(table.bottomHight || 181);

        // 左边元素起始宽度
        resize.top = top.offsetHeight;
        // console.log("高度：", resize.top);
        // 鼠标拖动事件
        document.onmousemove = function (e) {
          // 鼠标拖动的终止位置
          let endY = e.clientY;

          // （endx-startx）= 移动的距离
          //  resize.left + 移动的距离 = 左边区域最后的宽度
          let moveLen = resize.top + (endY - startY);
          // console.log(moveLen,this);



          // 左右两边区域的总宽度 = 大容器宽度 - 中间区域拖拉框的宽度
          let maxWidth = box.clientHeight - resize.offsetHeight;

          // 限制上边区域的最小高度为200px
          if (moveLen < 200){
            moveLen = 200;
          }
          
          // 只改变表格的高度预算，外层随内容撑开，避免固定高度露出背景。
          _this.topHeight = Math.max(reservedHeight + 54, startTableHeight + moveLen - resize.top);

          // 右边区域最小宽度为 150px 限制左边区域到150后不能再拉宽
          // if (moveLen > maxWidth - 420) moveLen = maxWidth - 420;

          // 设置左边区域的宽度，通过换算为百分比的形式，实现窗体放大缩小自适应
          // console.log((moveLen / maxWidth) * 100);
          // top.style.width =(moveLen / maxWidth * 100) + '%';

          // 右边区域即是总大小 - 左边宽度 - 拖动条宽度
          // console.log(((maxWidth - moveLen) / maxWidth) * 100);

          // 先注释:  底下的高度不改变
          // bottom.style.height = maxWidth - moveLen + "px";
          // _this.bottomHeight = maxWidth - moveLen - 20;

          // console.log(moveLen);
        };
        // 鼠标松开事件
        document.onmouseup = function (evt) {
          // console.log(11);
          document.onmousemove = null;
          document.onmouseup = null;
          resize.releaseCapture && resize.releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
        };
        resize.setCapture && resize.setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
        return false;
      };
    },
    handleMasterTableRefresh() {
      this.$emit('master-table-refreshed');
    },
    // 彻底锁定主表滚动：狂滚也不会触发页面滚动
    lockMainTableScroll() {
      const bind = () => {
        const master = this.$refs.master;
        if (!master || !master.$el) return;
        // 同时锁定两层容器（防止漏）
        const wrappers = [
          master.$el.querySelector('.el-table__body-wrapper'),
          master.$el.querySelector('.el-table__body')
        ].filter(Boolean);
        wrappers.forEach(el => {
          // 同时监听 wheel + mousewheel（全兼容）
          ['wheel', 'mousewheel'].forEach(evt => {
            el.addEventListener(evt, (e) => {
              const { scrollTop, scrollHeight, clientHeight } = el;
              const isTop = scrollTop <= 1; // 容错
              const isBottom = scrollTop + clientHeight >= scrollHeight - 2;
              // 只要在边界，**彻底阻止**
              if ((e.deltaY < 0 && isTop) || (e.deltaY > 0 && isBottom)) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation(); // 阻止同元素其他监听
                return false;
              }
            }, { passive: false, capture: true }); // 捕获阶段就拦截
          });
        });
      };
      // 等表格渲染完
      setTimeout(bind, 500);
      // 再补一次（防异步渲染）
      setTimeout(bind, 1000);
    },
  },
  mounted() {
    // this.getData();
    this.dragControllerDiv();
    // 加上这一行 → 锁住主表滚动，不冒泡到页面
    this.lockMainTableScroll();
  },
  async activated() {
    // if (this.firstEnter) {
    //   this.firstEnter = false;
    // } else {
    //   await this.getData();
    //   this.$refs.table.$refs.child.onLoad();
    // }
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-icon-folder-opened,
/deep/.el-icon-folder {
  color: rgb(255, 192, 1) !important;
}

.aymc-item {
  flex: 1;
  padding-left: 7px;

  &:hover {
    color: #2e5ae8;
    cursor: pointer;
  }
}

.active-item {
  color: #2e5ae8;
}

/deep/.elx-table.has--tree-line .elx-tree--btn-wrapper,
/deep/.elx-table .elx-body--row.row--current {
  color: #3e34c9 !important;
}


/* 拖拽相关样式 */
.box {
  width: 100%;
  height: 100%;
  margin: 1% 0px;
  overflow: hidden;
  position: relative;
}
/*左侧div样式*/
.top {
  width: 100%;
  height: auto;
  // float: left;
}
/*拖拽区div样式*/
.resize {
  cursor: row-resize;
  // float: left;
  position: relative;
  // top: 45%;
  background-color: #d6d6d6;
  border-radius: 5px;
  // margin-top: 50px;
  width: 100%;
  height: 10px;
  background-size: cover;
  background-position: center;
  /*z-index: 99999;*/
  font-size: 7px;
  text-align: center;
  color: white;
}
/*拖拽区鼠标悬停样式*/
.resize:hover {
  color: #444444;
}
/*底部div'样式*/
.bottom {
  // float: left;
  width: 100%;
  height: 50%; /*右侧初始化宽度*/
}

// 强制主表滚动不冒泡到页面
::v-deep .top .el-table__body-wrapper {
  overscroll-behavior-y: contain !important; /* 核心：阻止滚动溢出 */
  overflow-y: auto !important;
}

// 整个容器禁止滚动传播
.box {
  overscroll-behavior-y: contain;
}
</style>

